import dayjs from 'dayjs';
import {Timer} from 'lucide-react';
import {useEffect, useState} from 'react';
import {useIdleTimer} from 'react-idle-timer';

import {Typography} from './ui/typography';

export type IdleTimerCountdownProps = {
  timeout: number;
  onIdle: () => void;
};

const IdleTimerCountdown = ({timeout, onIdle}: IdleTimerCountdownProps) => {
  const [remaining, setRemaining] = useState(timeout);
  const {getRemainingTime} = useIdleTimer({
    onIdle,
    timeout: timeout * 1000,
    throttle: 1000,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime]);

  const duration = dayjs.duration(remaining, 'seconds');

  const h = duration.hours();
  const m = duration.minutes();
  const s = duration.seconds();

  const formattedTime = h
    ? `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    : `${m}:${s.toString().padStart(2, '0')}`;

  if (!remaining) return null;

  return (
    <div className="flex flex-row items-center gap-1 rounded-full bg-white px-2 py-1 shadow-subtle">
      <Timer size={16} className="text-neutral-800" />
      <Typography variant="label">{formattedTime}</Typography>
    </div>
  );
};

export default IdleTimerCountdown;
